export default {
  apiKey: "AIzaSyCkDmk8aKKZAqf-nX1qfNZtosNupomjPYo",
  authDomain: "vtes-online-274308.firebaseapp.com",
  databaseURL: "https://vtes-online-274308.firebaseio.com",
  projectId: "vtes-online-274308",
  storageBucket: "vtes-online-274308.appspot.com",
  messagingSenderId: "416594300029",
  appId: "1:416594300029:web:7ad935a974803f147fb514"
};
